import RateCourseService from "../../apiServices/student/studentRateCourseService";
import { IRateCourseData } from "../../models/student/studentCourceDetail";
import { HttpStatusCode } from "axios";
import { alertConstants } from "../../helper/sweet-alert";
import { setCourceRateDetail } from "../../store/slices/student/studentCourseRateSlice";

export function createStudentCourseRate(data: IRateCourseData, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await RateCourseService.createStudentCourseRate(data);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict);
      }
      else {
        callback(alertConstants.error);
      }
    }
  };
}

export function getCourseRatingDetails(courseId: number) {
  return async function (dispatch: any, getState: any) {
    let response = await RateCourseService.getStudentCourseRate(courseId)
    if (response?.success === true) {
      dispatch(setCourceRateDetail(response.data));
    } else {
      console.log("error");
    }
  };
}